'use strict';

const HOVER_DELAY = 40;
const VISIBLE_CLASS = 'cc-visible';

const SELECTORS = {
    tile: '.js-tile',
    tileUrl: '.js-tile-url',
    primaryImage: '.js-tile-image',
    secondaryImage: '.js-tile-image-secondary'
};

let hoverTimer = null;

function revealSecondaryImage($secondary) {
    $secondary.addClass(VISIBLE_CLASS);
}

/**
 * Shows the tile's secondary image, loading it only on the first real hover
 * and waiting for it to finish loading to avoid a flash before the crossfade.
 * @param {jQuery} $tile - tile being hovered
 */
function showSecondaryImage($tile) {
    const $primary = $tile.find(SELECTORS.primaryImage).eq(0);
    const $secondary = $tile.find(SELECTORS.secondaryImage).eq(0);
    const secondaryUrl = $primary.attr('data-secondary-img');
    const secondaryEl = $secondary.get(0);

    if (!secondaryEl || !secondaryUrl) {
        return;
    }

    if ($secondary.attr('src') !== secondaryUrl) {
        $secondary.off('load').attr('src', secondaryUrl);
    }

    if (secondaryEl.complete) {
        revealSecondaryImage($secondary);
    } else {
        $secondary.one('load', function () {
            revealSecondaryImage($secondary);
        });
    }
}

/**
 * @param {jQuery} $tile - tile being left
 */
function hideSecondaryImage($tile) {
    $tile.find(SELECTORS.secondaryImage).eq(0).off('load').removeClass(VISIBLE_CLASS);
}

module.exports = function () {
    // Bound to the click-area-only anchor (not the whole tile): swatches and
    // buttons sit above it (higher z-index), so hovering them naturally
    // triggers mouseleave here without any extra exclusion logic.
    $(document).on('mouseenter', SELECTORS.tileUrl, function () {
        if (!window.isDesktop) {
            return;
        }

        const $tile = $(this).closest(SELECTORS.tile);
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
            showSecondaryImage($tile);
        }, HOVER_DELAY);
    });

    $(document).on('mouseleave', SELECTORS.tileUrl, function () {
        if (!window.isDesktop) {
            return;
        }

        clearTimeout(hoverTimer);
        hideSecondaryImage($(this).closest(SELECTORS.tile));
    });

    // If the selected swatch changes while the tile is already in hover state
    // (swatches stay clickable above the overlay), resync the shown image.
    $(document).on('swatchSelector:imageChange', SELECTORS.primaryImage, function () {
        const $tile = $(this).closest(SELECTORS.tile);

        if ($tile.find(SELECTORS.secondaryImage).eq(0).hasClass(VISIBLE_CLASS)) {
            showSecondaryImage($tile);
        }
    });
};
